import { DependencyList, useEffect } from 'react';

export const useSubmitShortcut = (enabled: boolean, onSubmit: () => void, deps: DependencyList = []) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (!enabled || event.key !== 'Enter' || (!event.metaKey && !event.ctrlKey)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            onSubmit();
        };

        document.addEventListener('keydown', handleKeyDown, { capture: true });

        return () => {
            document.removeEventListener('keydown', handleKeyDown, { capture: true });
        };
    }, [enabled, onSubmit, ...deps]);
};
